"use client";
import Link from "next/link";
import React from "react";
import Image from "next/image";
import { useState, useEffect } from "react";

// const movies = [
//   {
//     title: "Ctanhtpaa",
//     image: "/assets/img/movie-1.jpg",
//     genre: "Psychological, Teen",
//     duration: "1h 55m",
//     rating: "18+",
//     description: "A wild adventure in the Amazon rainforest.",
//     price: "250",
//     showTimes: [
//       { day: "Monday", times: ["12:00 PM", "07:20 PM", "09:45 PM"] },
//       { day: "Tuesday", times: ["12:00 PM", "03:30 PM", "07:20 PM"] },
//       { day: "Wednesday", times: ["03:30 PM", "07:20 PM", "09:45 PM"] },
//       { day: "Thursday", times: ["12:00 PM", "07:20 PM", "09:45 PM"] },
//       { day: "Friday", times: ["12:00 PM", "03:30 PM", "09:45 PM"] },
//     ],
//   },
//   {
//     title: "Thor",
//     image: "/assets/img/movie-2.jpg",
//     genre: "Sci-Fi, Action",
//     duration: "2h 10m",
//     rating: "PG-13",
//     description: "A futuristic journey into a neon-lit urban landscape.",
//     price: "300",
//     showTimes: [
//       { day: "Monday", times: ["12:00 PM", "07:20 PM", "09:45 PM"] },
//       { day: "Tuesday", times: ["12:00 PM", "03:30 PM", "07:20 PM"] },
//       { day: "Wednesday", times: ["03:30 PM", "07:20 PM", "09:45 PM"] },
//       { day: "Thursday", times: ["12:00 PM", "07:20 PM", "09:45 PM"] },
//       { day: "Friday", times: ["12:00 PM", "03:30 PM", "09:45 PM"] },
//     ],
//   },
// ];

const movieFaqs = [
  {
    question: "How can I book movie tickets at Arena Water Park?",
    answer:
      "You can book tickets directly at our ticket counter or through our official website under the Cinema section. Simply select your movie and showtime to proceed with the booking.",
  },
  {
    question: "What types of movies are shown in Cinema?",
    answer:
      "We showcase a variety of movies, including the latest Hollywood and Bollywood blockbusters, family-friendly animations, and popular regional hits.",
  },
  {
    question: "Are there any discounts for children or senior citizens?",
    answer:
      "Yes, we offer special discounted pricing for children under 12 and senior citizens. Please check our 'Timings & Pricing' page for detailed information.",
  },
  {
    question: "Is outside food allowed inside the cinema hall?",
    answer:
      "To maintain the cleanliness and quality of our cinema, outside food and beverages are not permitted. We have a snack bar offering popcorn, nachos, drinks, and other refreshments.",
  },
  {
    question: "Do you offer group bookings for movies?",
    answer:
      "Yes, we provide special arrangements and bulk discounts for school trips, corporate outings, and private parties. Please contact our management team for more details.",
  },
];

export default function Movies() {
  const [movie, setMovie] = useState([]);
  const [loading, setLoading] = useState(true);
  const [movieFaqs, setMovieFaqs] = useState([]);

  useEffect(() => {
    const fetchMovieFaqs = async () => {
      try {
        const response = await fetch("/api/moviesfaqs");
        const data = await response.json();
        setMovieFaqs(data);
      } catch (error) {
        console.error("Failed to fetch movie faqs:", error);
      }
    };
    fetchMovieFaqs();
    const fetchMovie = async () => {
      try {
        const response = await fetch("/api/movies");

        const data = await response.json();
        const moviesData = (data.movies || []).map((item) => ({
          ...item,
          showTimes: Object.entries(item.showtimes || {})
            .filter(([_, times]) => times && times.length > 0)
            .map(([day, times]) => ({ day, times })),
        }));
        setMovie(moviesData);
      } catch (error) {
        console.error("Failed to fetch movies:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchMovie();
  }, []);

  return (
    <>
      <div
        className="breadcrumb-wrapper bg-cover"
        style={{
          backgroundImage: 'url("/assets/img/banners/cinema_bg_new.webp")',
        }}
      >
        <div className="container">
          <div className="breadcrumb-wrapper-items">
            <div className="page-heading">
              <div className="breadcrumb-sub-title">
                <h1 className="wow fadeInUp" data-wow-delay=".3s">
                  Cinema
                </h1>
              </div>
              <ul
                className="breadcrumb-items wow fadeInUp"
                data-wow-delay=".5s"
              >
                <li>
                  <Link href={`/`}> Home </Link>
                </li>
                <li>
                  <i className="fa-sharp fa-solid fa-slash-forward" />
                </li>
                <li>Cinema</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="about-section fix section-padding">
        <div className="container cinemoviebox mb-5">
          {loading ? (
            <div className="text-center">
              <h3>Loading movies...</h3>
            </div>
          ) : (
            <div className="row">
              {movie.map((item, index) => (
                <div key={index} className="col-lg-6 mb-4">
                  <div className="card h-100">
                    <img
                      src={item.image}
                      alt={item.title}
                      style={{
                        height: "300px",
                        width: "100%",
                        objectFit: "cover",
                      }}
                      className="img-fluid"
                    />
                    <div className="card-body">
                      <h4>{item.title}</h4>
                      <div className="row">
                        <div className="col pb-2">
                          <p>
                            <strong>Genre: </strong>
                            <br />
                            {Array.isArray(item.genre)
                              ? item.genre.join(", ")
                              : item.genre}
                          </p>
                        </div>
                        <div className="col pb-2">
                          <p>
                            <strong>Duration: </strong>
                            <br />
                            {item.duration}
                          </p>
                        </div>
                        <div className="col pb-2">
                          <p>
                            <strong>Rating: </strong>
                            <br />
                            {(() => {
                              const numRating = parseFloat(item.rating);
                              if (isNaN(numRating)) return item.rating;
                              const maxStars = 5;
                              const displayRating = numRating > 5 ? 5 : numRating;
                              return (
                                <span className="text-warning">
                                  {[...Array(maxStars)].map((_, i) => {
                                    const starValue = i + 1;
                                    if (starValue <= Math.floor(displayRating)) {
                                      return (
                                        <i
                                          key={i}
                                          className="fa-solid fa-star me-1"
                                        ></i>
                                      );
                                    } else if (
                                      starValue - 0.5 <=
                                      displayRating
                                    ) {
                                      return (
                                        <i
                                          key={i}
                                          className="fa-solid fa-star-half-stroke me-1"
                                        ></i>
                                      );
                                    } else {
                                      return (
                                        <i
                                          key={i}
                                          className="fa-regular fa-star me-1"
                                        ></i>
                                      );
                                    }
                                  })}
                                  <span className="text-dark ms-1">
                                    ({item.rating})
                                  </span>
                                </span>
                              );
                            })()}
                          </p>
                        </div>
                        <hr />
                        <div className="col-12">
                          <p>
                            <strong>Description</strong> <br />
                            {item.description}
                          </p>
                        </div>
                        <div className="col-12">
                          <div className="show-times">
                            {/* <ul>
                              {item.showTimes && item.showTimes.map((show, sIndex) => (
                                <li key={sIndex}>
                                  <strong>{show.day}</strong>:
                                  {show.times && show.times.map((time, tIndex) => (
                                    <span key={tIndex}>{time}</span>
                                  ))}
                                </li>
                              ))}
                            </ul> */}
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="row mt-auto">
                        {/* <div className="col-6">
                          <p>
                            <strong>Price Per Ticket</strong>
                          </p>
                          <h5>₹ {item.price}</h5>
                        </div> */}
                        <div className="col-12 text-center align-self-center ">
                          <Link href={`${item.link}`} className="testimonials-btn">
                            Book Tickets
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <section className="faq-section fix section-padding section-bg-2 bg-cover">
          <div className="container pb-4">
            <div className="row">
              <div className="col-lg-12">
                <h2 className="text-center pb-3">Movie FAQ's</h2>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-lg-10 faq-wrapper">
                <div className="faq-accordion">
                  <div className="accordion" id="movieAccordion">
                    {movieFaqs.map((faq, index) => (
                      <div
                        key={index}
                        className="accordion-item mb-3 wow fadeInUp"
                        data-wow-delay={`${0.2 * (index + 1)}s`}
                      >
                        <h5 className="accordion-header">
                          <button
                            className={`accordion-button ${
                              index === 0 ? "" : "collapsed"
                            }`}
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#faq${index}`}
                            aria-expanded={index === 0}
                            aria-controls={`faq${index}`}
                          >
                            {faq.question}
                          </button>
                        </h5>
                        <div
                          id={`faq${index}`}
                          className={`accordion-collapse collapse ${
                            index === 0 ? "show" : ""
                          }`}
                          data-bs-parent="#movieAccordion"
                        >
                          <div className="accordion-body">{faq.answer}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
